import * as React from 'react';

function SvgIphoneStatusbarBottom(props) {
	return (
		<svg width={375} height={50} viewBox="0 0 327 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path fill="#fff" d="M0 0h375v50H0z" />
			<path
				d="M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12zM323.667 3H313v3.333h1.333v-2h9.334c.4 0 .666.267.666.667v7.333c0 .4-.266.667-.666.667H315v4.667h-3.533L309 19.6v-1.933h-2c-.4 0-.667-.267-.667-.667V9.667c0-.4.267-.667.667-.667h8.667V7.667H307c-1.133 0-2 .866-2 2V17c0 1.133.867 2 2 2h.667v3.4l4.2-3.4h4.466v-4.667h7.334c1.133 0 2-.866 2-2V5c0-1.133-.867-2-2-2z"
				fill="#49525D"
			/>
			<path
				d="M307.8 16.267h1.6l.4-1.067h2.066l.4 1.067h1.6l-2.266-5.933H310l-2.2 5.933zm3-4.267l.666 2.067h-1.333L310.8 12zM317 12.333c.733 0 1.733-.2 2.667-.666.933.466 2 .666 2.666.666V11s-.666 0-1.4-.267c.8-.8 1.4-2 1.4-3.733v-.667h-2V5H319v1.333h-2v1.334h3.933c-.133 1.2-.666 1.933-1.266 2.4a3.9 3.9 0 0 1-1.067-1.4h-1.4c.267.866.667 1.533 1.2 2.066-.667.267-1.267.267-1.4.267v1.333zM144 .723"
				fill="#49525D"
			/>
			<text x="50%" y="50%" fill="#49525D" dominantBaseline="middle" textAnchor="middle"></text>
		</svg>
	);
}

export default SvgIphoneStatusbarBottom;
